import { resourceType, roleAccessTypes } from '../../../constants';
import { UserModel } from '../../../models';
import { checkRBACAccess, isUserAdvertiser } from '../../../utils';

export function checkIsOnlyRtbCounties(user?: UserModel) {
  const isAdvertiser = isUserAdvertiser(user);
  const isOfferBookAvailable = checkRBACAccess(
    user,
    resourceType.OfferBookCountryStatistic,
    roleAccessTypes.read,
  );

  return !isOfferBookAvailable || (isAdvertiser && user.hasAttachedRtb);
}
